/**
 * Generate twitter share string
 * @param  {string} [url='']      url to share
 * @param  {string} [text='']     text for tweet
 * @param  {string} [via='']      via to include
 * @param  {string} [hashtags=''] hashtags to include
 * @return {string}               share url
 */
export default function twitterShare(
  url = '',
  text = '',
  via = '',
  hashtags = ''
) {
  const tweet = `${text} via ${via} ${hashtags}`;
  return `https://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(tweet)}`;
}



// WEBPACK FOOTER //
// ./app/services/share/twitter.js